import React from 'react';
import config from "../config";
import {withStyles} from '@material-ui/core/styles';
import {withRouter} from 'react-router';
import {Link} from "react-router-dom";


export class Footer extends React.Component {

  render() {
    const {classes} = this.props;

    return (
      <div className={classes.footer}>
        <div className="container">
          <div className="row">
            <div className={`${classes.section} col-md-4`}>
              <h3 className={classes.header}>Looking for staff?</h3>
              <ul className="list-unstyled">
                <li><Link to={config.routes.business} className={classes.link}>Home</Link></li>
                <li><Link to={config.routes.businessSignUp} className={classes.link}>Sign up</Link></li>
                <li><Link to={config.routes.businessLogin} className={classes.link}>Log in</Link></li>
                <li><Link to={config.routes.businessFaq} className={classes.link}>Frequently Asked Questions</Link></li>
                <li><Link to={config.routes.businessPricing} className={classes.link}>Pricing</Link></li>
              </ul>
            </div>
            <div className={`${classes.section} col-md-4`}>
              <h3 className={classes.header}>Looking for work?</h3>
              <ul className="list-unstyled">
                <li><Link to={config.routes.pros} className={classes.link}>Home</Link></li>
                <li><Link to={config.routes.prosSignUp} className={classes.link}>Sign up</Link></li>
                <li><Link to={config.routes.prosFaq} className={classes.link}>Frequently Asked Questions</Link></li>
              </ul>
            </div>
            <div className={`${classes.section} col-md-4`}>
              <h3 className={classes.header}>Contact</h3>
              <ul className="list-unstyled">
                <li>Email: hsuken@singleshift.sg</li>
                <li>WhatsApp: +65 8753 8329</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const styles = (theme) => ({
  footer: {
    backgroundColor: '#2C2D33',
    color: '#ffffff',
    padding: '100px 0 125px',
  },
  header: {
    fontSize: '20px',
    fontWeight: 'bold',
    marginBottom: '10px',
  },
  section: {
    marginBottom: '60px',
  },
  link: {
    color: '#ffffff',
  },
  '@media (min-width: 992px)': {
    header: {
      marginBottom: '30px',
    }
  },
});

export default withRouter(withStyles(styles)(Footer));



// WEBPACK FOOTER //
// ./src/parts/Footer.js